import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { Modal } from "@mui/material";
import { useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import { useState, useEffect } from "react";

const Loading = () => {
  const [reachedDelay, setReachedDelay] = useState(false);
  const { loading } = useSelector((state) => state.loading);

  useEffect(() => {
    if (loading) {
      setReachedDelay(false);
      const interval = setInterval(() => {
        setReachedDelay(true);
      }, 150);
      return () => {
        clearInterval(interval);
        setReachedDelay(false);
      };
    }
  }, [loading]);

  return (
    <Modal
      open={loading && reachedDelay}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          background: "#fefefe",
          height: 300,
          width: 500,
        }}
      >
        <CircularProgress />
        <Typography>Παρακαλω περιμένετε...</Typography>
      </Box>
    </Modal>
  );
};

export default Loading;
